
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { assertIsFn, AddContext } from "@storybook/addon-docs";

import { Description, Meta } from '@storybook/addon-docs';
import readme from '../../README.md';


const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Meta title="Introduction" mdxType="Meta" />
    <Description mdxType="Description">
  {readme.replace('[View Netlify Preview →](https://v-next--cloudfour-patterns.netlify.com/)', '[View GitHub Repository →](https://github.com/cloudfour/cloudfour.com-patterns)') // Weird link path due to this issue:
      // https://github.com/storybookjs/storybook/issues/9005
      .replace(/\[(.+)]\(CONTRIBUTING\.md\)/g, '<a href="../?path=/story/contributing--page">$1</a>')}
    </Description>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;

export const __page = () => { throw new Error("Docs-only story"); };

__page.parameters = { docsOnly: true };

const componentMeta = { title: 'Introduction', includeStories: ["__page"],  };

const mdxStoryNameToKey = {};

componentMeta.parameters = componentMeta.parameters || {};
componentMeta.parameters.docs = {
  ...(componentMeta.parameters.docs || {}),
  page: () => <AddContext mdxStoryNameToKey={mdxStoryNameToKey} mdxComponentAnnotations={componentMeta}><MDXContent /></AddContext>,
};

export default componentMeta;